import { Entity } from 'src/app/core/data/schema/entity';
import { Upload } from 'src/app/core/data/schema/upload';
import { SortOrder } from 'src/app/core/data/schema/sort-order';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { Raffle } from './raffle';

export class Sponsor extends Entity {
    static className = 'Sponsor';
    static idField = 'sponsorId';

    auctionId: number;
    raffleId: number;
    name: string;
    sponsorId: number;
    newBanner: string;
    bannerPath: string;
    logoPath: string;
    url: string;
    deleted: boolean;
    filename: string;
    sortOrder: number;

    // add this variable for auction details page
    tier: string;
    description: string;

    image: Upload = new Upload();

    constructor(sponsor?: Partial<Sponsor>) {
        super();
        Object.assign(this, sponsor);
        this.description = `Placeholder Description for ${this.name}`;

        if (this.logoPath != null) {
            this.image.path = this.logoPath;
            this.image.safeUrl = this.logoPath;
            this.image.isImage = true;
            this.image.isBlob = true;
        }
    }

    static async saveSortOrder(sortOrder: SortOrder[]) {
        const loader = await ServiceHelper.displayLoad('Saving sort order...');
        try {
            await super.factory.httpService.post(sortOrder, `sponsors/sort/${Raffle.currentRaffleId}`);
        } catch (error) {
            console.error(`Error saving sort order. ${error}`);
            throw error;
        } finally {
            loader.dismiss();
        }
    }
}
